import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

export const firebaseConfig = {
  apiKey: 'AIzaSyAjC2YYfZFYSkbn5kE8XndWDonnWZxe_3o',
  appId: '1:902451168995:web:441f05232bac722e4e27d6',
  messagingSenderId: '902451168995',
  projectId: 'instaflix-a48ff',
  authDomain: 'instaflix-a48ff.firebaseapp.com',
  storageBucket: 'instaflix-a48ff.firebasestorage.app',
  measurementId: 'G-QFM3D140QQ',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);

export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('email');
googleProvider.setCustomParameters({ prompt: 'select_account' });
